import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RightPanel from "@/components/RightPanel";
// import { AppMain, Navbar, Settings, Sidebar, TagsView } from "./components";
import { AppMain, Navbar, Sidebar, TagsView, Settings } from "./components";
// import ResizeMixin from "./mixin/ResizeHandler";
import HeadMenu from "@/layout/components/HeadMenu";
import { mapState } from "vuex";
export default {
  name: "Layout",
  components: {
    AppMain: AppMain,
    Navbar: Navbar,
    HeadMenu: HeadMenu,
    RightPanel: RightPanel,
    Settings: Settings,
    Sidebar: Sidebar,
    TagsView: TagsView
  },
  data: function data() {
    return {
      noHomePage: false
    };
  },
  // mixins: [ResizeMixin],
  computed: _objectSpread(_objectSpread({}, mapState({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    showSettings: function showSettings(state) {
      return state.settings.showSettings;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    bg: function bg(state) {
      return state.settings.bg;
    },
    navBarBg: function navBarBg(state) {
      return state.settings.navBarBg;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    },
    leftNavBg: function leftNavBg(state) {
      return state.settings.leftNavBg;
    }
  })), {}, {
    isMircoApp: function isMircoApp() {
      return window.__POWERED_BY_QIANKUN__;
    },
    classObj: function classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  }),
  watch: {
    $route: function $route(to, from) {
      // this.isShowSecondaryMenu(to.path)
    }
  },
  created: function created() {
    // this.isShowSecondaryMenu(this.$route.path)
  },
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", {
        withoutAnimation: false
      });
    } // isShowSecondaryMenu(path) {
    //   if (path === '/home') {
    //     this.noHomePage = false
    //   } else {
    //     this.noHomePage = true
    //   }
    // }
  }
};